import LsdApiModel  from './global/LsdApiModel';
import { computed } from 'mobx';
import moment       from 'moment';

export default class BankDetailModel extends LsdApiModel {
	static get path(): string {
		return '/bank_details/{?id}';
	}

	@computed
	public get accountNumber() {
		return this.get('accountNumber');
	}

	@computed
	public get active() {
		return this.get('active');
	}

	@computed
	public get address() {
		return this.get('address');
	}

	@computed
	public get addressBis() {
		return this.get('addressBis');
	}

	@computed
	public get city() {
		return this.get('city');
	}

	@computed
	public get bankDetailMediaIri() {
		return this.get('bankDetailMedia.@id');
	}

	@computed
	public get bankDetailMediaMediaFileName() {
		return this.get('bankDetailMedia.mediaFileName');
	}

	@computed
	public get bankDetailMediaObjectUrl() {
		return this.get('bankDetailMedia.objectUrl');
	}

	@computed
	public get bankName() {
		return this.get('bankName');
	}

	@computed
	public get zipCode() {
		return this.get('zipCode');
	}

	@computed
	public get beneficiaryName() {
		return this.get('beneficiaryName');
	}

	@computed
	public get bic() {
		return this.get('bic');
	}

	@computed
	public get country() {
		return this.get('country');
	}

	@computed
	public get createdAt() {
		return this.get('createdAt');
	}

	@computed
	public get createdAtMoment() {
		return moment(this.get('createdAt'));
	}

	@computed
	public get createdById() {
		return this.get('createdBy.id');
	}

	@computed
	public get currencyId() {
		return this.get('currency.id');
	}

	@computed
	public get currencyIri() {
		return this.get('currency.@id');
	}

	@computed
	public get iban() {
		return this.get('iban');
	}

	@computed
	public get main() {
		return this.get('main');
	}

	@computed
	public get supplierId() {
		return this.get('supplier.id');
	}

	@computed
	public get supplierIri() {
		return this.get('supplier.@id');
	}

	@computed
	public get title() {
		return this.get('title');
	}

	@computed
	public get updatedAt() {
		return this.get('updatedAt');
	}

	@computed
	public get updatedAtMoment() {
		return moment(this.get('updatedAt'));
	}

	@computed
	public get updatedById() {
		return this.get('updatedBy.id');
	}
}
